// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"PrefSrcButton_hide-scrollbar__vEUyX","prefSourceBtn":"PrefSrcButton_prefSourceBtn__iDh8f","filled-btn":"PrefSrcButton_filled-btn__OHRQ4"};